<template>
  <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4062_6216)">
      <path d="M2.90002 14.3996C4.22551 14.3996 5.30003 13.3251 5.30003 11.9996C5.30003 10.6741 4.22551 9.59961 2.90002 9.59961C1.57452 9.59961 0.5 10.6741 0.5 11.9996C0.5 13.3251 1.57452 14.3996 2.90002 14.3996Z" fill="white"/>
      <path d="M12.4996 14.3996C13.8251 14.3996 14.8996 13.3251 14.8996 11.9996C14.8996 10.6741 13.8251 9.59961 12.4996 9.59961C11.1741 9.59961 10.0996 10.6741 10.0996 11.9996C10.0996 13.3251 11.1741 14.3996 12.4996 14.3996Z" fill="white"/>
      <path d="M22.1002 14.3996C23.4257 14.3996 24.5002 13.3251 24.5002 11.9996C24.5002 10.6741 23.4257 9.59961 22.1002 9.59961C20.7747 9.59961 19.7002 10.6741 19.7002 11.9996C19.7002 13.3251 20.7747 14.3996 22.1002 14.3996Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_4062_6216">
        <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
      </clipPath>
    </defs>
  </svg>
</template>